export default "__VITE_ASSET__CnTxI2i1__"